import { handleResponseOld, makePost } from './helpers';
import { CatalogDetail } from '@/types/CatalogDetail';

/**
 * @category Item API
 * @see fetchCatalogDetailsByIds
 */
type FetchCatalogDetailsByIdsResponse = {
    data: {
        catalogDetails: CatalogDetail[];
    };
    message: string;
    success: boolean;
};

/**
 * @category Item API
 * @see fetchCatalogDetailsByIds
 */
type FetchCatalogDetailsByIdsParams = {
    catalogIds: number[];
    deployment: string;
};

/**
 * POST request to item-api service sents a list of catalogIds and returns catalog details
 * @function fetchCatalogDetailsByIds
 * @category Item API
 * @param {FetchCatalogDetailsByIdsParams}
 * @see https://item-api-DEPLOYMENT.liveauctioneers.com/spa/small/catalog-detail
 * @see https://github.com/LIVEauctioneers/item-api/blob/master/src/inventory/routes/post-catalog-detail.ts
 */
const fetchCatalogDetailsByIds = ({ catalogIds, deployment }: FetchCatalogDetailsByIdsParams) =>
    new Promise<FetchCatalogDetailsByIdsResponse>((resolve, reject) => {
        const request = makePost({ deployment, path: '<ITEM-API>spa/small/catalog-detail' });
        request.send({ ids: catalogIds });
        request.end((err, response) => handleResponseOld({ err, reject, resolve, response }));
    });

export default {
    fetchCatalogDetailsByIds,
};
